const isGtagValid = (eventName: Gtag.EventNames | string) => {
  const isValid = Boolean(window?.gtag);

  if (!isValid && process.env.NODE_ENV !== "development") {
    console.error("gtag not available to log event", {
      gtag: window?.gtag,
      eventName,
    });
  }

  return isValid;
};

/** Event names can be looked up in GTM (tagmanager.google.com) for configurations */
export enum CustomEventName {
  EMAIL_CAPTURE = "ga4_kids_email_capture",
  SUBSCRIPTION = "ga4_kids_subscription",
}

/**
 * Custom Email Capture event.
 */
export const eventEmailCapture = () => {
  const eventName = CustomEventName.EMAIL_CAPTURE;

  if (!isGtagValid(eventName)) {
    return;
  }

  window.gtag?.("event", eventName);
};

/**
 * Custom Kids Subscription event.
 */
export const eventSubscription = (eventParams: {
  value: string;
  estimatedLTV: string | number;
}) => {
  const eventName = CustomEventName.SUBSCRIPTION;

  if (!isGtagValid(eventName)) {
    return;
  }

  const { value, estimatedLTV } = eventParams || {};
  window.gtag?.("event", eventName, { value, estimated_ltv: estimatedLTV });
};

/**
 * Generic event function for built-in GTAG events.
 * */
export const gtagBuiltInEvent = (
  eventName: Gtag.EventNames,
  eventParams: Gtag.EventParams
) => {
  if (!isGtagValid(eventName)) {
    return;
  }

  window.gtag?.("event", eventName, eventParams);
};
